// extracted by mini-css-extract-plugin
module.exports = {"containerquery":"BenefitsModule_containerquery__26Wab","benefitsmodule":"BenefitsModule_benefitsmodule__7KHj8","benefitsimage":"BenefitsModule_benefitsimage__mYFHC"};